/* eslint-disable jquery/no-class */
/* eslint-disable jquery/no-html */
/* eslint-disable jquery/no-find */
/* eslint-disable jquery/no-text */
/* eslint-disable jquery/no-ajax */
import $ from 'jquery';
import { ResizeSensor } from 'css-element-queries';
import { onEvent } from '../util/domutils'; // eslint-disable-line import/named
import initCountrySelector from './header/countrySelector';
import throttle from './throttle';

export const SELECTORS = {
  HEADER: '.header-sticky',
  BOTTOM_BANNER: '.header-banner-bottom',
  BANNER_CLOSE_BUTTON: '.close-button',
  MENU_CATS: '.cat-Imagery',
};

const CACHE = {
  RESIZE_SENSOR: null,
  RESIZE_HANDLERS: [],
};

export const EVENTS = {
  UPDATE_HEADER: 'header:update',
};

const handleResizeEvents = (height) => {
  CACHE.RESIZE_HANDLERS.forEach((handler) => {
    handler(height);
  });
};

export const initBannerClose = () => {
  const headerBottomBanner = document.querySelector(SELECTORS.BOTTOM_BANNER);

  if (headerBottomBanner) {
    onEvent(headerBottomBanner, 'click', SELECTORS.BANNER_CLOSE_BUTTON, () => {
      const cookieName = headerBottomBanner.dataset.closeCookie;

      document.cookie = `${cookieName}=true; path=/`;
      headerBottomBanner.remove();
    });
  }
};

export const functions = {
  getHeaderHeight(header = document.querySelector(SELECTORS.HEADER)) {
    if (header) {
      const headerRectangle = header.getBoundingClientRect();
      const headerOffset = headerRectangle.top;
      const headerHeight = header.offsetHeight;
      const headerDisplacement = Math.ceil(headerHeight + headerOffset);

      return headerDisplacement;
    }

    return 0;
  },
  onHeightChange(cb) {
    CACHE.RESIZE_HANDLERS.push(cb);
  },
};

export const initResizeHandler = () => {
  const header = document.querySelector(SELECTORS.HEADER);

  if (header) {
    CACHE.RESIZE_SENSOR = new ResizeSensor(header, () => {
      handleResizeEvents(functions.getHeaderHeight(header));
    });
  }
};


export const initHandleNewsletterValidation = () => {
  $(document).on('submit', '.email-newsletter__form:not(".validated")', function (e) {
    e.preventDefault();
    const $form = $(this);
    const emailField = document.querySelector('.email-newsletter__email-input');
    // eslint-disable-next-line jquery/no-attr
    const requrestUrl = $(this).attr('data-emailvalidate');
    const dataObj = new FormData();
    dataObj.append('email', emailField.value);
    if (emailField) {
      $.ajax({
        url: requrestUrl,
        contentType: false,
        processData: false,
        type: 'post',
        data: dataObj,
        success(data) {
          if (!data.success) {
            $form.find('.invalid-feedback').html(data.error);
            emailField.classList.add('is-invalid');
          } else {
            // eslint-disable-next-line jquery/no-class
            $form.addClass('validated');
            // eslint-disable-next-line jquery/no-trigger
            $form.trigger('submit');
          }
        },
      });
      return false;
    }
    return true;
  });
};

export const pdComponentsJs = () => {
  $(document).ready(() => {
    $('.show-more').on('click', function () {
      // eslint-disable-next-line jquery/no-class
      $('.mission-copy-sign').removeClass('limit-height');
      // eslint-disable-next-line jquery/no-class, jquery/no-parent
      $(this).parent('.readmore-wrapper').removeClass('d-flex').addClass('d-none');
    });
  });
};

export const searchfocus = () => {
  $(document).ready(() => {
    $('.header-search').on('click', () => {
      // eslint-disable-next-line jquery/no-class
      $('.clearfix-self .search-field').focus();
    });
  });
};

export const removeEmoji = () => {
  $(document).on('change keyup', '.removeEmoji', function () {
    // eslint-disable-next-line max-len
    const regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
    $(this).val($(this).val().replace(regex, '')); // eslint-disable-line jquery/no-val
  });
};

export const initScroll = () => {
  let startX; // To store the starting touch position
  let scrollLeft; // To store the current scroll position

  $('.cat-Imagery').on('touchstart', function (e) {
    const touch = e.originalEvent.touches[0]; // Get the touch event
    startX = touch.pageX - $(this).offset().left; // Calculate start position relative to container
    scrollLeft = $(this).scrollLeft(); // Get current scroll position
  });

  $('.cat-Imagery').on('touchmove', function (e) {
    const touch = e.originalEvent.touches[0]; // Get the touch event
    const x = touch.pageX - $(this).offset().left; // Calculate current position
    const walk = (x - startX) * 1.5; // Calculate how far to scroll
    $(this).scrollLeft(scrollLeft - walk); // Scroll the container
  });
};

// Calculate header-banner height for scroll offset
export function getPageOffset() {
  const banner = document.querySelector('.header-banner');
  const bannerHeight = banner ? Math.ceil(banner.getBoundingClientRect().height || 0) : 28;
  return bannerHeight;
}

// Track virtual keyboard state
let isVirtualKeyboardOpen = false;
let initialViewportHeight = window.innerHeight;
let searchInputFocused = false;

/**
 * Get virtual keyboard state
 */
export const isKeyboardOpen = () => isVirtualKeyboardOpen;

/**
 * Function to calculate viewport height difference
 * @returns {Object} Object containing current height and height difference
 */
const getViewportHeightDifference = () => {
  const currentHeight = window.innerHeight;
  const heightDifference = initialViewportHeight - currentHeight;
  const KEYBOARD_THRESHOLDS = {
    OPEN: 150,
    CLOSED: 100,
  };

  return {
    currentHeight,
    heightDifference,
    isKeyboardLikelyOpen: heightDifference > KEYBOARD_THRESHOLDS.OPEN,
    isKeyboardClosed: heightDifference < KEYBOARD_THRESHOLDS.CLOSED,
  };
};

/**
 * Detect virtual keyboard open/close
 */
export const detectVirtualKeyboard = () => {
  const { isKeyboardLikelyOpen, isKeyboardClosed } = getViewportHeightDifference();

  // If height decreased by more than 150px, assume keyboard is open
  if (isKeyboardLikelyOpen) {
    if (!isVirtualKeyboardOpen) {
      isVirtualKeyboardOpen = true;
    }
  } else if (isVirtualKeyboardOpen && isKeyboardClosed && !searchInputFocused) {
    isVirtualKeyboardOpen = false;
    initialViewportHeight = window.innerHeight;
  }
};

/**
 * Initialize virtual keyboard detection
 */
export const initVirtualKeyboardDetection = () => {
  window.addEventListener('resize', detectVirtualKeyboard);

  // Listen for focus on search input to prevent hiding
  const searchInput = document.querySelector('.header-item__search.lower .site-search .search-field');
  if (searchInput) {
    searchInput.addEventListener('focus', () => {
      searchInputFocused = true;
      isVirtualKeyboardOpen = true;
    });

    searchInput.addEventListener('blur', () => {
      searchInputFocused = false;

      setTimeout(() => {
        const { isKeyboardLikelyClosed } = getViewportHeightDifference();

        // Only close if viewport height suggests keyboard is actually closed
        if (isKeyboardLikelyClosed) {
          isVirtualKeyboardOpen = false;
          initialViewportHeight = window.innerHeight;
        }
      }, 500);
    });
  }
};

/**
 * Handle search icon click to scroll and focus search input
 */
export const initSearchIconClick = (searchIconSelector = '.header-element__search[data-toggle="search-mobile"]') => {
  const header = document.querySelector(SELECTORS.HEADER);
  const searchIconElement = document.querySelector(searchIconSelector);

  if (!header || !searchIconElement) {
    return;
  }

  searchIconElement.addEventListener('click', (e) => {
    e.preventDefault();

    header.classList.remove('scroll-down');
    header.classList.add('scroll-up');

    const observer = new MutationObserver((mutations) => {
      mutations.forEach(() => {
        if (header.classList.contains('scroll-down')) {
          header.classList.remove('scroll-down');
          header.classList.add('scroll-up');
        }
      });
    });
    observer.observe(header, { attributes: true, attributeFilter: ['class'] });

    const PAGE_OFFSET = getPageOffset();
    window.scrollTo({
      top: (PAGE_OFFSET + 2),
      behavior: 'smooth',
    });

    const OBSERVE_MS = 200;
    setTimeout(() => {
      observer.disconnect();
      const searchInput = document.querySelector(
        '.header-item__search.lower .site-search .search-field',
      );
      if (searchInput) {
        header.classList.add('scroll-up');
        header.classList.remove('scroll-down');
        searchInput.focus({ preventScroll: true });
      }
    }, OBSERVE_MS);
  });
};

/**
 * Handle search bar visibility on scroll (after header-banner)
 */
const handleSearchScroll = () => {
  const SCROLL_INTERVAL = 150;
  const PAGE_OFFSET = getPageOffset();
  const siteSearch = document.querySelector('.header-item__search.lower .site-search');

  if (!siteSearch) return;

  window.addEventListener('scroll', throttle(() => {
    // Don't hide search if virtual keyboard is open
    if (isKeyboardOpen()) return;

    if (window.pageYOffset > PAGE_OFFSET) {
      siteSearch.classList.add('search-visible');
    } else {
      siteSearch.classList.remove('search-visible');
    }
  }, SCROLL_INTERVAL));
};

// Helper to add class to menu drawer (for mobile)
const addSubnavClass = () => {
  document.querySelectorAll('.nav-menu__search .site-search').forEach((el) => {
    el.classList.add('drawer');
  });
};

export const initComponents = () => {
  initCountrySelector();
  handleSearchScroll();
  addSubnavClass();
  initVirtualKeyboardDetection();
};

export const handleErrorSummaryVisibility = () => {
  $('.checkout-shipping__type').on('click', function () {
    // eslint-disable-next-line jquery/no-attr
    if ($(this).attr('data-type') === 'store') {
      // eslint-disable-next-line jquery/no-hide
      $('.error-summary-container').hide();
    } else {
      // eslint-disable-next-line jquery/no-show
      $('.error-summary-container').show();
    }
  });
};
